import WorkQDeferredCustomSelect from "./WorkQDeferredCustomSelect"
import { useEffect, useMemo, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { filterActions } from "../../../store/filter"
import { caseQuickUpdate } from "../../../lib/fetchApi"
import { notificationActions } from "../../../store/notifications"
import { frontendOptions } from "../../../lib/systemData"

function surgeryApprovalStatusOptions() {
    return frontendOptions()?.surgeryApprovalStatus ?? []
}

function needsApprovalFlag(item, previousDisplayValue, nextValue) {
    if (nextValue == null || nextValue === "") {
        return false
    }

    const approval = item?.step_3_approval
    if (approval == null || approval === 0 || approval === "0") {
        return true
    }

    if (previousDisplayValue == null && approval === undefined) {
        return true
    }

    return false
}

export default function SurgeryApprovalStatusCell({ data, item, caseData, subItem }) {
    const dispatch = useDispatch()
    const userToken = useSelector((state) => state.user.token)
    const selectedWorkQueue = useSelector((state) => state.workqueue.selectedWorkQueue)
    const workqSlug = selectedWorkQueue?.slug || selectedWorkQueue
    const [localValue, setLocalValue] = useState(data)
    const [isSaving, setIsSaving] = useState(false)

    const dbField = subItem?.field ?? "step_3_approval_status"
    const rowLabel = subItem?.label ?? "approval_status"

    const identifier = useMemo(
        () => ({
            type: "case_surgeries",
            field: dbField,
            type_id: item.id,
            folder: "surgeries",
            case_id: caseData?.case?.id,
        }),
        [caseData?.case?.id, dbField, item.id],
    )

    useEffect(() => {
        setLocalValue(data)
    }, [data])

    async function updateHandler(payload, previousValue, nextValue) {
        setIsSaving(true)

        const fields = {
            [dbField]: nextValue,
        }

        const rowFields = [{ field: rowLabel, value: nextValue }]

        if (needsApprovalFlag(item, previousValue, nextValue)) {
            fields.step_3_approval = 1
            rowFields.push({ field: "step_3_approval", value: 1 })
        }

        const reqBody = {
            type: identifier.type,
            type_id: identifier.type_id,
            workq: workqSlug,
            fields,
        }

        const dispatchBody = {
            case_id: identifier.case_id,
            folder: identifier.folder,
            item: {
                itemId: identifier.type_id,
                fields: rowFields,
            },
        }

        const update = await caseQuickUpdate(userToken, identifier.case_id, reqBody, dispatch, true)

        if (update && update.errorMessage) {
            setLocalValue(previousValue)
            dispatch(
                filterActions.updateItemInWorkQRow({
                    case_id: identifier.case_id,
                    folder: identifier.folder,
                    item: {
                        itemId: identifier.type_id,
                        fields: [{ field: rowLabel, value: previousValue }],
                    },
                }),
            )
            dispatch(notificationActions.setError(update))
        } else {
            dispatch(
                notificationActions.setError({
                    errorMessage: "Your changes have been successfully saved to the case.",
                    type: "success",
                }),
            )
            dispatch(filterActions.updateItemInWorkQRow(dispatchBody))
        }

        setIsSaving(false)
    }

    function onChange(payload) {
        const previousValue = localValue
        const nextValue = payload?.data?.value ?? null
        setLocalValue(nextValue)

        const rowFields = [{ field: rowLabel, value: nextValue }]
        if (needsApprovalFlag(item, previousValue, nextValue)) {
            rowFields.push({ field: "step_3_approval", value: 1 })
        }

        dispatch(
            filterActions.updateItemInWorkQRow({
                case_id: identifier.case_id,
                folder: identifier.folder,
                item: {
                    itemId: identifier.type_id,
                    fields: rowFields,
                },
            }),
        )
        updateHandler(payload, previousValue, nextValue)
    }

    return (
        <div style={{ position: "relative" }}>
            <WorkQDeferredCustomSelect
                fixedDrawer={true}
                hasRemove={true}
                getOptionsData={surgeryApprovalStatusOptions}
                preSelectedValue={localValue}
                action={onChange}
                name={dbField}
                identifier={identifier}
                sameSizeAsContainer={true}
                minWidth={150}
                isLoading={isSaving}
                undetermined="—"
            />
        </div>
    )
}
